import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(IShiftDropAccessor, 'IShiftDropAccessor');
initMetadataForInterface(IShiftTradeAccessor, 'IShiftTradeAccessor');
initMetadataForClass(Bid, 'Bid');
initMetadataForClass(ShiftDrop, 'ShiftDrop');
initMetadataForClass(ShiftTrade, 'ShiftTrade');
initMetadataForInterface(IShiftDropMutator, 'IShiftDropMutator', VOID, VOID, VOID, [1, 2]);
initMetadataForInterface(IShiftTradeMutator, 'IShiftTradeMutator', VOID, VOID, VOID, [1, 2]);
//endregion
function IShiftDropAccessor() {
}
function IShiftTradeAccessor() {
}
function Bid(id) {
  this.d8c_1 = id;
}
protoOf(Bid).toString = function () {
  return 'Bid(id=' + this.d8c_1 + ')';
};
protoOf(Bid).hashCode = function () {
  return this.d8c_1;
};
protoOf(Bid).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Bid))
    return false;
  var tmp0_other_with_cast = other instanceof Bid ? other : THROW_CCE();
  if (!(this.d8c_1 === tmp0_other_with_cast.d8c_1))
    return false;
  return true;
};
function ShiftDrop(id, bids) {
  this.e8c_1 = id;
  this.f8c_1 = bids;
}
protoOf(ShiftDrop).toString = function () {
  return 'ShiftDrop(id=' + this.e8c_1 + ', bids=' + toString(this.f8c_1) + ')';
};
protoOf(ShiftDrop).hashCode = function () {
  var result = this.e8c_1;
  result = imul(result, 31) + hashCode(this.f8c_1) | 0;
  return result;
};
protoOf(ShiftDrop).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftDrop))
    return false;
  var tmp0_other_with_cast = other instanceof ShiftDrop ? other : THROW_CCE();
  if (!(this.e8c_1 === tmp0_other_with_cast.e8c_1))
    return false;
  if (!equals(this.f8c_1, tmp0_other_with_cast.f8c_1))
    return false;
  return true;
};
function ShiftTrade(uuid) {
  this.g8c_1 = uuid;
}
protoOf(ShiftTrade).toString = function () {
  return 'ShiftTrade(uuid=' + this.g8c_1 + ')';
};
protoOf(ShiftTrade).hashCode = function () {
  return getStringHashCode(this.g8c_1);
};
protoOf(ShiftTrade).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftTrade))
    return false;
  var tmp0_other_with_cast = other instanceof ShiftTrade ? other : THROW_CCE();
  if (!(this.g8c_1 === tmp0_other_with_cast.g8c_1))
    return false;
  return true;
};
function IShiftDropMutator() {
}
function IShiftTradeMutator() {
}
//region block: exports
export {
  IShiftDropAccessor as IShiftDropAccessor3c2fgb3dksv1c,
  IShiftTradeAccessor as IShiftTradeAccessorqhpl7uylbpey,
  Bid as Bid1s5165cmyi3p0,
  ShiftDrop as ShiftDrop11wleufu73phm,
  ShiftTrade as ShiftTrade2id415mgfo6y4,
  IShiftDropMutator as IShiftDropMutatoryf0dvdej6sad,
  IShiftTradeMutator as IShiftTradeMutatorrs3huyo9trn7,
};
//endregion

